let activeId: number | null = null;
let nextId = 1;

/** Synchronous lease acquisition prevents two mounted controls from crossing an
 * await boundary before either knows about the other. Busy/finalizing sessions
 * retain their lease so a second control cannot silently discard a transcript. */
export function acquireDictationLease(): number | null {
    if (activeId !== null) return null;
    const id = nextId++;
    activeId = id;
    return id;
}

export function isCurrentDictationLease(id: number): boolean {
    return activeId === id;
}

export function releaseDictationLease(id: number): void {
    if (activeId === id) activeId = null;
}
